import { makeRequest } from 'utils/requestLogger';

export default (participationID, payload) =>
    makeRequest(
        'put',
        `/api/participations/${participationID}/draft_feedback_for_student`,
        payload
    );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/addDraftFeedbackForStudent.js